import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import Consts from "../utilities/Consts";
import * as NetworkHelper from "../utilities/Networkhelper";

import CommonHelper from "../utilities/CommonHelper";
import { useStateValue } from "../utilities/StateProvider";

/*
  <Column field="stk_kodu" header={cLabels.stok_code} sortable filter headerStyle={{ width: "120px" }}/>
          <Column field="stk_adi" header={cLabels.stok_name} sortable filter style={{ width: "250px" }} headerStyle={{ width: "300px" }}/>
          <Column field="toplam" header={Consts.localizedStrings.rezerve_stok_sip_goderilecek_saraplar.toplam_adet} sortable filter headerStyle={{ width: "120px" }}/>

*/
const ini_filter = {
  stk_kodu: { value: null, matchMode: Consts.KEYS.FilterMatchMode.STARTS_WITH },
  stk_adi: { value: null, matchMode: Consts.KEYS.FilterMatchMode.STARTS_WITH },
  toplam: { value: null, matchMode: Consts.KEYS.FilterMatchMode.EQUALS },
};

export const RezerveStokSipGonderilecekSaraplar = (props) => {
  const {} = props;
  const cLabels = Consts.localizedStrings;
  const baseUrl = Consts.network.rezerve_stok_sip;
  const [{ user, userLanguage }, dispatch] = useStateValue();
  const defaultSortField = "stk_kodu";

  const [dataTableLoading, setDataTableLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [datalist, setDatalist] = useState([]);
  const [datalistFromDb, setDatalistFromDb] = useState([]); //dbden gelen data
  const [sortField, setSortField] = useState(defaultSortField);
  const [sortOrder, setSortOrder] = useState(-1);
  const [first, setFirst] = useState(0);
  const [datalistFetchLimit, setDatalistFetchLimit] = useState(100);
  const [offSetStartNum, setOffSetStartNum] = useState(0);
  const [offSetEndNum, setOffSetEndtNum] = useState(100);
  const [totalFetchedCount, setTotalFetchedCount] = useState(100);

  const [globalFilter, setGlobalFilter] = useState(undefined);
  const [filters, setFilters] = useState(ini_filter);
  const [formData, setFormData] = useState({});
  const [timerID, setTimerID] = useState(0);
  const dt = useRef(undefined);
  const isFirstRender = useRef(true);

  useEffect(() => {
    dispatch({
      type: "SET_PAGE_HEADER",
      pageHeader: cLabels.rezerve_stok_sip_goderilecek_saraplar_header,
    });
  }, [userLanguage]);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      init();
    }
  });
  const init = async () => {
    await Promise.all([_onList()])
      .then((values) => {
        
      })
      .catch((error) => {
        CommonHelper.handleCatch(error);
      });
  };

  const _onList = async (_filters = filters, _globalFilter = globalFilter, _sortField = sortField, _sortOrder = sortOrder) => {
    try {
      setDataTableLoading(true);
      setSortField(_sortField);
      setSortOrder(_sortOrder);

      let response = await NetworkHelper.call_web_service(baseUrl.list, {
        ..._filters,
        sd_gonderi_status: "0",
        sd_cancel_on: "0",
        sum_fields: ["stk_adet"],
        group_by_fields: ["stk_adi", "stk_kodu"],
        globalFilter: _globalFilter,
        orderByField: _sortField,
        orderBy: _sortOrder === 1 ? "ASC" : "DESC",
        offset: offSetStartNum,
        limit: datalistFetchLimit,
      });
      setDatalist(response.datalist);
      setDatalistFromDb(response.datalist);
      setTotalRecords(response.count);
      setTotalFetchedCount(totalFetchedCount);
    } catch (error) {
      console.log("._onList.catch", error);
      CommonHelper.handleCatch(error);
    } finally {
      setDataTableLoading(false);
    }
  };
  const onPage = async (_first=first) => {
    let _datalistFromDb = datalistFromDb;
    try {
      if (offSetStartNum <= _first && _first < offSetEndNum) {
        _datalistFromDb = _datalistFromDb.slice((_first - offSetStartNum)%datalistFetchLimit)
      } else {
        setDataTableLoading(true);
        let response = await NetworkHelper.call_web_service(baseUrl.list, {
          ...filters,
          sd_gonderi_status: "0",
          sd_cancel_on: "0",
          globalFilter: globalFilter,
          orderByField: sortField,
          orderBy: sortOrder === 1 ? "ASC" : "DESC",
          offset: _first,
          limit: datalistFetchLimit,
        });
        setDatalistFromDb(response.datalist);
        _datalistFromDb = response.datalist;
        setTotalRecords(response.count);
        setOffSetStartNum(_first);
        setOffSetEndtNum(_first + datalistFetchLimit);
      }

     
      setDatalist(_datalistFromDb);
      setFirst(_first);
    } catch (error) {
      console.log(".onPage.catch", error);
      CommonHelper.handleCatch(error);
    } finally {
      setDataTableLoading(false);
    }
  }; //=>end _dataListFetch

  const _onFilter = async (_filters = filters, _globalFilter = globalFilter) => {
    setFilters(_filters);
    await _onList(_filters, _globalFilter, sortField, sortOrder);
  };
  const initFilters = () => {
    setFirst(0);
    setGlobalFilter("");
    setFilters(ini_filter);
    _onFilter(ini_filter, null);
  };
  const onGlobalFilterChange = (e) => {
    setGlobalFilter(e.target.value);
    clearInterval(timerID);
    setTimerID(
      setTimeout(() => {
        const value = e.target.value;
        _onFilter(filters, value);
      }, Consts.filterDelay)
    );
  };
  const paginatorRight = () => {
    return (
      <div>
        {user.user_level == 1 && (
          <Button
            type="button"
            icon="pi pi-file-excel"
            className="p-button-success p-button-sm"
            onClick={() => {
              CommonHelper.exportExcel(dispatch, cLabels.rezerve_stok_sip_goderilecek_saraplar_header, dt, baseUrl.list, { ...filters, sd_gonderi_status: "0", sd_cancel_on: "0" }, globalFilter, sortField, sortOrder);
            }}
          />
        )}
      </div>
    );
  };

  const header = (
    <div className="table-header">
      <Button type="button" icon="pi pi-filter-slash" label={cLabels.clear} className="p-button-outlined" onClick={initFilters} />
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText value={globalFilter} onChange={onGlobalFilterChange} placeholder={cLabels.keyword_search} />
      </span>
    </div>
  );
  return (
    <div className="content-section implementation datatable-filter-demo">
      <div className="card">
        <DataTable
          reorderableColumns
          value={datalist}
          dataKey={"stk_kodu"}
          id="idx"
          rowHover
          ref={dt}
          selectionMode="single"
          className="p-datatable-sm"
          selection={formData}
          paginator
          currentPageReportTemplate={cLabels.datatable_empty_mesaage}
          rows={Consts.defaultRowsCountDataTable}
          lazy={true}
          totalRecords={totalRecords}
          sortField={sortField}
          sortOrder={sortOrder}
          paginatorRight={paginatorRight}
          paginatorLeft={`    `}
          onSort={(event) => _onList(filters, globalFilter, event.sortField, event.sortOrder)}
          onPage={(event) => {
            onPage(event.first);
          }}
          onFilter={(e) => {
            _onFilter(e.filters);
          }}
          filters={filters}
          showGridlines resizableColumns 
          filterDisplay="row"
          filterDelay={Consts.filterDelay}
          first={first}
          emptyMessage={cLabels.datatable_empty_mesaage}
          loading={dataTableLoading}
          header={header}
          stripedRows
          scrollable
        >
          <Column field="stk_kodu" header={cLabels.stok_code} sortable filter headerStyle={{ width: "120px" }} />
          <Column field="stk_adi" header={cLabels.stok_name} sortable filter style={{ width: "250px" }} headerStyle={{ width: "300px" }} />
          <Column field="sum_stk_adet" header={cLabels.toplam_adet} dataType="numeric" headerStyle={{ width: "120px" }} />
        </DataTable>
      </div>
    </div>
  );
};
